<template>
    <div class="container">
        <div
            class="d-flex flex-wrap justify-content-between align-items-center w-100"
        >
            <div class="d-flex align-items-center justify-content-start">
                <div class="h4">{{ componentTitle }}</div>
                <div
                    class="ml-3 d-flex align-items-center justify-content-center',"
                >
                    <button
                        class="p-2 d-flex align-items-center saved-video-edit-remove-btn btn btn-primary"
                        tabindex="0"
                        @click="toggleEditSection"
                        @keydown.enter="toggleEditSection"
                        @keydown.space.prevent="toggleEditSection"
                        v-if="editSection"
                    >
                        {{ editLabel }}
                        <img
                            class="ml-3"
                            src="../../../src/app/assets/glyphs/pencil.svg"
                            alt=""
                        />
                    </button>
                    <div v-else class="d-flex align-items-center">
                        <button
                            @click="handleRemoveVideos"
                            @keydown.enter="handleRemoveVideos"
                            @keydown.space.prevent="handleRemoveVideos"
                            class="saved-video-edit-remove-btn btn btn-primary text-white d-flex p-2"
                            tabindex="0"
                        >
                            <img
                                class="mr-2"
                                src="../../../src/app/assets/glyphs/trash.svg"
                                alt=""
                            />
                            <div>{{ removeLabel }}</div>
                        </button>
                        <div>
                            <button
                                type="button"
                                class="saved-video-edit-remove-btn btn btn-primary ml-4"
                                @click="handelCancel"
                                @keydown.enter="handelCancel"
                                @keydown.space.prevent="handelCancel"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-start">
                <p class="font-weight-bold mr-2">{{ filterLabel }}</p>
                <p class="font-weight-bold">
                    <select
                        v-model="selectedCategory"
                        class="p-2 border border-text-muted"
                    >
                        <option value="All" name = "All">{{ filterAllContent }}</option>
                        <option
                            v-for="(option, index) in parsedDropdownValues"
                            :key="index"
                            :value="option"
                            :name="option"
                        >
                            {{ option }}
                        </option>
                    </select>
                </p>
            </div>
        </div>
        <div class="row" v-if="editSection">
            <div
                class="col-12 col-md-6 col-lg-3 p-4"
                v-for="video in filteredVideos"
                :key="video.VideoId"
                @click="openModal(video)"
            >
                <div
                    class="c-article-card c-article-card--small c-article-card--video"
                >
                    <button
                        class="c-article-card__background"
                        type="button"
                        :id="video.VideoItemId"
                        :teaseritemid="video.VideoCategoryId"
                        :videoid="video.VideoId"
                        videotitle="What should a patient know before genome sequencing?"
                        :videotypelink="video.VideoId"
                        videofullcontentlink="/en/videos/interpreting-incidentally-identified-variants-in-genes-associated-with-heritable-cardiac-disease"
                        videoteaser="Svati Shah, MD, MHS, Andrew Landstrom, MD, PhD, and Anwar Chahal, MD, PhD, FACC, MRCP, FESC discuss the importance of understanding incidental variants in genomic sequencing and what research participants and patients should know about exome or genome sequencing, the significance of informed consent, and how to engage in meaningful conversations with healthcare providers to ensure empowered decision-making."
                        videocategoryid=""
                        @click="openModal(video)"
                    >
                        <span
                            class="h-placeholder-image h-placeholder-image--3-2"
                        >
                            <img :src="video.Thumbnail" class="is-loaded" />
                        </span>
                        <span class="c-article-card__video-overlay">
                            <span class="c-article-card__play"
                                ><img
                                    src="/assets/glyphs/play.svg"
                                    alt="play"
                                />Watch Video</span
                            >
                        </span>
                    </button>
                    <div class="c-article-card__content">
                        <h3 class="c-article-card__title h6">
                            {{ video.Title }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container">
                <div
                    class="row justify-content-start align-items-center text-center w-100"
                    v-for="video in filteredVideos"
                    :key="video.VideoId"
                >
                    <div
                        class="col-12 col-md-1 d-flex flex-column align-items-center"
                    >
                        <input
                            width="24px"
                            height="24px"
                            type="checkbox"
                            class="saved-video-checkbox-large mb-2"
                            @click="
                                handleSelectedVideos(
                                    video.VideoItemId,
                                    video.VideoCategoryId
                                )
                            "
                            style="cursor: pointer; position: relative"
                        />
                        <span class="text-dark font-weight-bold">{{
                            selectLabel
                        }}</span>
                    </div>
                    <div class="col-12 col-md-3 p-4">
                        <div
                            class="c-article-card c-article-card--small c-article-card--video"
                        >
                            <button
                                class="c-article-card__background"
                                type="button"
                                :id="video.VideoItemId"
                                :teaseritemid="video.VideoCategoryId"
                                :videoid="video.VideoId"
                                videotitle="What should a patient know before genome sequencing?"
                                :videotypelink="video.VideoId"
                                videofullcontentlink="/en/videos/interpreting-incidentally-identified-variants-in-genes-associated-with-heritable-cardiac-disease"
                                videoteaser="Svati Shah, MD, MHS, Andrew Landstrom, MD, PhD, and Anwar Chahal, MD, PhD, FACC, MRCP, FESC discuss the importance of understanding incidental variants in genomic sequencing and what research participants and patients should know about exome or genome sequencing, the significance of informed consent, and how to engage in meaningful conversations with healthcare providers to ensure empowered decision-making."
                                videocategoryid=""
                                @click="openModal(video)"
                            >
                                <span
                                    class="h-placeholder-image h-placeholder-image--3-2"
                                >
                                    <img
                                        :src="video.Thumbnail"
                                        class="is-loaded"
                                    />
                                </span>
                                <span class="c-article-card__video-overlay">
                                    <span class="c-article-card__play"
                                        ><img
                                            src="/assets/glyphs/play.svg"
                                            alt="play"
                                        />Watch Video</span
                                    >
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="col-12 col-md-7">
                        <p class="text-left font-weight-bold mt-2 text-dark">
                            {{ video.Title }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="filteredVideos.length === 0"
            class="text-center text-muted mt-4"
        >
            <div class="h3 d-flex justify-content-center align-center">
                No videos found
            </div>
        </div>
        <aha-modal
            id="save-video-modal"
            class="c-modal--aha"
            title="Modal Header"
            size="md"
            hide-footer
            centered
            v-model="isModalOpen"
            ref="loadingModal"
            @@hide="handleAhaModalClose"
        >
            <div class="loader-container" role="alert" aria-live="assertive">
                <div class="loader">Loading...</div>
            </div>
            <div v-if="selectedVideoUrl">
                <b-embed
                    id="communityEmbedVideo"
                    type="iframe"
                    allow="autoplay"
                    aspect="16by9"
                    :src="selectedVideoUrl"
                    allowfullscreen
                >
                </b-embed>
                <div class="row align-items-center w-100 ml-0">
                    <div
                        class="col-lg-12 c-promotion__title__wrapper w-100 px-0"
                    >
                        <div
                            id="modalTitle"
                            class="c-promotion__title w-100 text-center mb-3 saved-video-modal-title"
                            :style="{ fontSize: '18px' }"
                        >
                            {{ selectedVideoTitle }}
                        </div>
                    </div>
                </div>
                <div
                    class="mx-auto d-flex justify-content-center"
                    id="modalTeaser"
                >
                    {{ selectedVideoTeaser }}
                </div>
                <div
                    class="mx-auto mt-3 c-promotion__modal-buttons d-flex justify-content-center"
                >
                    <a
                        id="aFullContentLink"
                        class="mb-lg-0 mb-3 mr-lg-5 mr-0 btn btn-lg btn-round btn-danger"
                        target="_blank"
                        :href="videofullcontentlink"
                    >
                        See Full Content
                    </a>
                </div>
            </div>
            <p v-else class="text-center text-muted">No video selected</p>
        </aha-modal>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props: {
        componentTitle: { type: String, default: "" },
        editLabel: { type: String, default: "" },
        removeLabel: { type: String, default: "" },
        filterLabel: { type: String, default: "" },
        filterAllContent: { type: String, default: "All" },
        selectLabel: { type: String, default: "" },
        savedVideos: { type: Array, default: () => [] },
        saveEndpoint: { type: String, default: "" },
        filterDropdownValues: { type: [Array, String], default: () => [] },
    },
    data() {
        return {
            editSection: true,
            selectedVideos: { videos: [], isdelete: true },
            selectedCategory: "All",
            selectedVideoUrl: "",
            selectedVideoTitle: "",
            selectedVideoTeaser: "",
            videofullcontentlink: "",
            isModalOpen: false,
        };
    },
    computed: {
        filteredVideos() {
            let videos = this.savedVideos;
            if (typeof videos === "string") {
                try {
                    videos = JSON.parse(videos);
                } catch (error) {
                    console.error(
                        "Invalid JSON format for savedVideos:",
                        error
                    );
                    return [];
                }
            }
            if (!Array.isArray(videos)) {
                console.error("savedVideos is not an array:", videos);
                return [];
            }
            if (this.selectedCategory !== "All") {
                videos = videos.filter(
                    (video) =>
                        video.VideoCategory.trim() ===
                        this.selectedCategory.trim()
                );
            }
            const videoMap = new Map();
            videos.forEach((video) => {
                videoMap.set(video.VideoId, video);
            });
            return Array.from(videoMap.values());
        },
        parsedDropdownValues() {
            try {
                if (typeof this.filterDropdownValues === "string") {
                    return JSON.parse(this.filterDropdownValues).map((item) =>
                        item.replace(/&#160;/g, " ")
                    );
                } else if (Array.isArray(this.filterDropdownValues)) {
                    return this.filterDropdownValues.map((item) =>
                        item.replace(/&#160;/g, " ")
                    );
                }
                return [];
            } catch (error) {
                console.error("Error parsing filterDropdownValues:", error);
                return [];
            }
        },
    },
    methods: {
        toggleEditSection() {
            this.editSection = !this.editSection;
        },
        handleRemoveVideos() {
            axios
                .post(this.saveEndpoint, this.selectedVideos)
                .then((res) => {
                    console.log("Response:", res);
                    window.location.reload();
                })
                .catch((err) => {
                    console.error("Error:", err);
                });
        },

        handleSelectedVideos(videoId, categoryid) {
            const index = this.selectedVideos.videos.findIndex(
                (v) => v.videoId === videoId
            );
            if (index === -1) {
                this.selectedVideos.videos = [
                    ...this.selectedVideos.videos,
                    { videoId, categoryid },
                ];
            } else {
                this.selectedVideos.videos = this.selectedVideos.videos.filter(
                    (v) => v.videoId !== videoId
                );
            }
        },
        openModal(video) {
            if (video) {
                this.selectedVideoUrl = video.VideoUrl;
                this.selectedVideoTitle = video.Title;
                this.selectedVideoTeaser = video.Teaser;
                this.videofullcontentlink = video.VideoFullContentLink;
                this.showModal(); // Function to open the modal
            }
        },
        showModal() {
            this.$root.$emit("bv::show::modal", "save-video-modal");
        },
        handelCancel() {
            this.editSection = !this.editSection;
        },
    },
    watch: {
        isModalOpen(newVal) {
            if (!newVal) {
                this.selectedVideoUrl = ""; // Stop video when modal closes
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// demo/pages/components/aha-saved-videos.vue